import Vue from 'vue';
import VueRouter from 'vue-router';
import {routers} from './router';
import LoadingBar from '@/components/loading-bar';
import Util from '../lib/util';
import Cookies from 'js-cookie'
import { appRouters} from './router'
import store from '@/store/index';
// import breadcrumbRoutes from "@/store/modules/breadcrumbRoutes";
Vue.use(VueRouter);

const RouterConfig = {
    // mode: 'history',
    routes: routers
};

export const router = new VueRouter(RouterConfig);

router.beforeEach((to, from, next) => {
    LoadingBar.start();
    store.commit('breadcrumbRoutes/entry',to);
    console.log(store.state["breadcrumbRoutes"].routers);
    // Util.title(to.meta.title);
    if(to.path.startsWith("/mobile")){ //移动端不做权限验证
        Util.toDefaultPage([...appRouters], to.name, router, next);
    }else{
        if (Cookies.get('locking') === '1' && to.name !== 'locking') {
            next({
                replace: true,
                name: 'locking'
            });
        }else if (Cookies.get('locking') === '0' && to.name === 'locking') {
            next(false);
        } else {
            if (!Util.abp.currentUser&& to.name !== 'login' && to.name!=='wxredirect') {
                next({
                    name: 'login'
                });
            } else if (!!Util.abp.currentUser && to.name === 'login') {
                Util.title(to.meta.title);
                next({
                    name: 'home'
                });
            } else {
                const curRouterObj = Util.getRouterObjByName([...appRouters], to.name);
                if (curRouterObj && curRouterObj.permission) {
                    if (window.abp.auth.hasPermission(curRouterObj.permission)) {
                        Util.toDefaultPage([...appRouters], to.name, router, next);
                    } else {
                        next({
                            replace: true,
                            name: 'error-403'
                        });
                    }
                } else {
                    Util.toDefaultPage([...routers], to.name, router, next);
                }
            }
        }
    }
});
router.afterEach((to) => {
    // Util.openNewPage(router.app, to.name, to.params, to.query);
    LoadingBar.finish();
    window.scrollTo(0, 0);
});
